var $ = require("jquery");
var utils = require('../../utilities/js/utils');

var selectors = {
    filtersFormDesktop: '[data-filters-form="desktop"]',
    filtersFormMobile: '[data-filters-form="mobile"]',
    filterCategory: '[data-select="category"]',
    filterSort: '[data-select="sort"]'
};

/**
 * Parse filters form values
 * @param {*} form
 * @returns {Array}
 */
function parseForm(form, selectType) {
    var formValues = [];
    var $form = $(form);
    var $formInputs = $form.find(selectType);
    var defaultFilterVal = 'all';

    Array.from($formInputs).forEach(function(element) {
        $el = $(element);
        var filterVal = $el.val();
        var isNotDefault = filterVal !== defaultFilterVal;
        var isUnique = formValues.indexOf(filterVal) === -1;

        if (isNotDefault && isUnique) {
            if(formValues.indexOf() == -1) {
                formValues.push(filterVal);
            }
        }
    });

    return formValues;
}

/**
 * Build a URLSearchParams instance from an object (e.g. {key: "value"})
 * @param {Object} queryParams
 */
function buildURLSearchParams(obj) {
    var params = new URLSearchParams();
    for (var key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            var value = obj[key];
            if(value) {
                params.append(key, value);
            }

        }
    }
    return params;
}

/**
 * Build a query string from passed in values and refresh the page
 * @param {Array} categoryValues
 * @param {Array} sortValues
 */
function refreshFilters(categoryValues, sortValues) {
    var params = {
        "category": categoryValues.join("|"),
        "sort": sortValues.join("|")
    }
    var urlSearchParams = buildURLSearchParams(params);
    var urlSearchParamsStr = urlSearchParams.toString();
    var urlPath = window.location.pathname;
    var redirectPath = urlPath;

    if (urlSearchParamsStr) {
        redirectPath = redirectPath + "?" + urlSearchParams;
    } else {
        redirectPath = urlSearchParamsStr;
    }
    window.location.href = redirectPath;
}

/**
 * Handle desktop form changes
 * @param {JQueryEvent} e
 */
function onDesktopFormChange(e) {
    var categoryValues = parseForm(selectors.filtersFormDesktop, selectors.filterCategory);
    var sortValues = parseForm(selectors.filtersFormDesktop, selectors.filterSort);
    refreshFilters(categoryValues, sortValues);
}

/**
 * Handle mobile form changes
 * @param {JQueryEvent} e
 */
function onMobileFormChange(e) {
    var categoryValues = parseForm(selectors.filtersFormMobile, selectors.filterCategory);
    var sortValues = parseForm(selectors.filtersFormMobile, selectors.filterSort);
    refreshFilters(categoryValues, sortValues);
}

// Event listenters
$(selectors.filtersFormDesktop).on('change', onDesktopFormChange);
$(selectors.filtersFormMobile).on('change', onMobileFormChange);

// Mobile filters clicked
$('[data-mobile-filter-toggle]').on('click', function() {

})

// Flip the mobile "fake select" error on toggle of the collapsable category filters
$('#mobileFilterCollapse').on('hide.bs.collapse', function () {

    // add 'chosen-container-active'
    // add 'chosen-with-drop'
});

$('#mobileFilterCollapse').on('show.bs.collapse', function () {

    // remove 'chosen-container-active'
    // remove 'chosen-with-drop'
});



//////////////////
// WEBPACK FOOTER
// ./educators/js/educatorsCategoryFilters.js
// module id = 137
// module chunks = 3